/**
 * Module Federation host entry point.
 * The actual app is imported dynamically via bootstrap.tsx so that
 * all shared singleton modules (react, react-router, zustand) are
 * negotiated with remotes BEFORE any app code runs.
 */
import("./bootstrap");
